import styled from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScDashboardPanel = styled.div<{ isOpen: boolean }>`
  position: relative;
  cursor: pointer;
  height: 48px;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.grayLightColor};
  padding: 0px 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  .loyalty-panel {
    position: relative;
    display: flex;
    align-items: center;
    gap: 4px;

    .level {
      z-index: 2;
      ${typography.body1bold}
      white-space: nowrap;
    }
  }

  & > i {
    width: 16px;
    transform: rotate(${({ isOpen }) => (isOpen ? '-90deg' : '90deg')});
    transition: color 0.3s ease;
    color: ${({ theme, isOpen }) =>
      isOpen ? theme.whiteColor : theme.blackLightColor};
  }

  & > .popup {
    position: absolute;
    right: 0;
    top: 52px;
    z-index: 100;
    cursor: default;
  }

  @media (hover: hover) {
    &:hover {
      & > i {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }
`;
